<template>
    <div class="form pwds-form" autocomplete="nope">
        <LoadingLight id="pwdModal"/>

        <div class="form-row" v-if="clientInfos.sso_activation.length > 0">
            <label class="form-label form-label-spe">{{ $t('users.password.connectionType') }}</label>
            <div class="radio-group">
                <label>
                    <input type="radio" name="connectType" value="password" v-model="selectedUserAuthProvider">
                    <span>{{ $t('global.suivideflotte') }}</span>
                </label>
                <label>
                    <input type="radio" name="connectType" value="Google" v-model="selectedUserAuthProvider">
                    <span>{{ $t('global.google') }}</span>
                </label>
              <label>
                    <input type="radio" name="connectType" value="Graph" v-model="selectedUserAuthProvider">
                    <span>{{ $t('global.microsoft') }}</span>
                </label>
            </div>
        </div>
        <br>

        <div class="auth-params sdf-auth" :class="{show:isSdfAuth}" v-if=" this.selectedUser.id == authUser.user.iduser">
            <div class="form-row">
                <label class="form-label hide-on-mobile" for="pwd">{{ $t('users.password.newPassword') }}</label>
                <Password id="pwd" name="pwd" ref="pwdField" class="password-strength with-generator" :defaultClass="'form-input'" :placeholder="''" v-validate="passwordValidateRule"
                          :secureLength="secureLength" v-model="selectedUserAuthSecret"></Password>
                <label class="hide-on-desktop" for="pwd">{{ $t('users.password.newPassword') }}</label>
                <div class="password-generator" title="Générer un mot de passe aléatoire sécurisé" @click="generatePwd"><font-awesome-icon icon="key"/></div>
                <transition name="fade">
                                <span v-show="errors.has('password')" class="form-input-error"
                                      @click="hideError('password')">{{ errors.first('password') }}</span>
                </transition>
            </div>
            <div class="form-row">
                <label class="form-label hide-on-mobile" for="pwdConfirm">{{ $t('users.password.confirm') }}</label>
                <input type="password" id="pwdConfirm" name="pwdConfirm" class="form-input" autocomplete="new-password" v-validate="passwordValidateRule"
                       v-model="pwdConfirm"/>
                <label class="hide-on-desktop" for="pwdConfirm">{{ $t('users.password.confirm') }}</label>
                <font-awesome-icon icon="check-square" v-show="pwdsMatch"/>
                <transition name="fade">
                                <span v-show="errors.has('pwdConfirm')" class="form-input-error"
                                      @click="hideError('pwdConfirm')">{{ errors.first('pwdConfirm') }}</span>
                </transition>
            </div>
        </div>

        <div class="auth-params google-auth" :class="{show:isGoogleAuth}">
            <div class="form-row">
                <label class="form-label hide-on-mobile" for="providerAccount">{{ $t('users.password.googleLogin') }}</label>
                <input type="text" id="providerAccount" name="providerAccount" class="form-input" required  v-model="selectedUserAuthSecret" v-validate="providerAccountValidateRule"/>
                <label class="hide-on-desktop" for="providerAccount">{{ $t('users.password.googleLogin') }}</label>
                <transition name="fade">
                                <span v-show="errors.has('providerAccount')" class="form-input-error"
                                      @click="hideError('providerAccount')">{{ errors.first('providerAccount') }}</span>
                </transition>
            </div>
        </div>
      <div class="auth-params microsoft-auth" :class="{show:isMicrosoftAuth}">
            <div class="form-row">
                <label class="form-label hide-on-mobile" for="identifiant">{{ $t('users.password.microsoftLogin') }}</label>
                <input type="text" id="identifiant" name="identifiant" class="form-input" required  v-model="selectedUserAuthSecret" v-validate="providerAccountValidateRule"/>
                <label class="hide-on-desktop" for="identifiant">{{ $t('users.password.microsoftLogin') }}</label>
                <transition name="fade">
                                <span v-show="errors.has('identifiant')" class="form-input-error"
                                      @click="hideError('identifiant')">{{ errors.first('identifiant') }}</span>
                </transition>
            </div>
        </div>

        <Btn class="primary desktop-block mobile-block" style="margin-right: 0" :class="{disabled:disabledSave}" v-if="!inline"
             @click.native="saveForm">{{ $t('global.save') }}
        </Btn>

    </div>
</template>

<script>
    //import Component from 'path/to/component'

    import Password from 'vue-password-strength-meter'
    import LoadingLight from '@c/ui/LoadingLight'

    import {mapGetters, mapActions, mapMutations} from 'vuex'

    import generatePassword from 'password-generator'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Password,
            LoadingLight
        },
        computed: {
            ...mapGetters({
                clientInfos: 'Papers/clientInfos',
                selectedUser: 'Users/selectedUser',
                authUser: 'Auth/user'
            }),

            selectedUserAuthProvider: {
                get() {
                    return this.$store.state.Users.selectedUser.auth.provider
                },
                set(value) {
                    this.$store.commit('Users/selectedUserAuthField', {field:'provider',value:value})
                }
            },
            selectedUserAuthSecret: {
                get() {
                    return this.$store.state.Users.selectedUser.auth.secret
                },
                set(value) {
                    this.$store.commit('Users/selectedUserAuthField', {field:'secret',value:value})
                }
            },

            secureLength() {
                return 8
            },
            isSdfAuth(){
                return this.selectedUserAuthProvider == 'password'
            },
            isGoogleAuth(){
                return this.selectedUserAuthProvider == 'Google'
            },
            isMicrosoftAuth(){
                return this.selectedUserAuthProvider == 'Graph'
            },

            passwordValidateRule(){
                /*if(this.isSdfAuth){
                    return 'required'
                }*/
                return ''
            },

            providerAccountValidateRule(){
                if(this.isGoogleAuth || this.isMicrosoftAuth){
                    return 'required'
                }
                return ''
            },

            disabledSave(){
                if(this.isSdfAuth){
                    if(!this.pwdsOK || !this.pwdsMatch){
                        return true;
                    }
                }
                return false;

            }
        },
        created: function () {

        },
        data() {
            return {
                pwd: '',
                pwdConfirm: '',
              //TODO a supprimer apres les tests de validation
                pwdsOK: true,
                pwdsMatch: true,
              //FIn TODO
                authType: 'Null',
                googleAccount: '',
                microsoftAccount: ''
            }
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                showLoadingLight: 'UI/showLoadingLight',
                closeModal: 'UI/closeModal',
                addSuccess: 'Messages/addSuccess',
                addError: 'Messages/addError'
            }),

            ...mapActions({
                changePassword: 'Users/changePassword'
            }),

            checkPasswords() {
                if (this.pwdsOK) {
                    if (this.selectedUserAuthSecret == this.pwdConfirm) {
                        this.pwdsMatch = true;
                    }
                    else {
                        this.pwdsMatch = false;
                    }
                }
                else {
                    this.pwdsMatch = false;
                }
            },

            validateForm() {
                return this.$validator.validateAll()
            },

            hideError(field) {
                this.errors.remove(field);
            },

            saveForm() {
                this.validateForm()
                    .then(result => {
                        if(result){
                            if ((this.isSdfAuth && this.pwdsOK && this.pwdsMatch) || this.isGoogleAuth || this.isMicrosoftAuth) {
                                this.showLoadingLight({id: 'pwdModal', show: true})

                                let userChangePassword = {
                                    id: this.props.user.id,
                                    user: {
                                        auth: {
                                            provider: this.selectedUserAuthProvider,
                                            secret: this.selectedUserAuthSecret,
                                        }
                                    }
                                }

                                if(this.clientInfos.customFields && this.clientInfos.customFields.user){
                                    userChangePassword.user['customs'] = this.selectedUser.customs
                                }

                                this.changePassword(userChangePassword)
                                    .then(response => {
                                        this.addSuccess(t("users.message.success"))
                                        this.showLoadingLight({id: 'pwdModal', show: false})
                                        this.closeModal();
                                    })
                                    .catch(error => {
                                        if(error.response.status == 422){
                                            Object.keys(error.response.data.message).map((objectKey, index) => {
                                                let item = error.response.data.message[objectKey];
                                                if(Array.isArray(item)){
                                                    item.forEach(errorMsg => {
                                                        this.addError(errorMsg);
                                                    })
                                                }
                                                else{
                                                    this.addError(item);
                                                }

                                            })
                                        }
                                        else{
                                            this.addError(error.response.data.message);
                                        }


                                        this.showLoadingLight({id: 'pwdModal', show: false})
                                    });
                            }
                        }
                    })


            },
            generatePwd(){
                let pwdGenerated = generatePassword(12, false)
                this.$refs.pwdField.emitValue(pwdGenerated)
                this.selectedUserAuthSecret = this.pwdConfirm = pwdGenerated
            }
        },
        mounted: function () {
            //this.showLoadingLight({id:'pwdModal',show:true})
        },
        name: '',
        props: {
            props: {
                type: Object,
                required: true
            },
            inline: {
                type: Boolean,
                default: false
            }
        },
        updated: function () {

        },
        watch: {
            selectedUserAuthProvider(newVal, oldVal){
                this.selectedUserAuthSecret = ''
                this.pwdConfirm = ''
                this.pwdsOK = false
                this.pwdsMatch = false
            },
            selectedUserAuthSecret(newVal, oldVal) {
                if (newVal.length >= this.secureLength) {
                    this.pwdsOK = true;
                }
                else {
                    this.pwdsOK = false;
                }
                this.checkPasswords()
            },
            pwdConfirm(newVal, oldVal) {
                this.checkPasswords()
            },

        }
    }
</script>

<style lang="scss">
    .password-strength {
        max-width: none !important;
        padding: 0;
        width: 100%;

        input {
            background-color: transparent;
            border: none;

        }

        .Password__strength-meter{
            margin: 10px auto 0;
        }

        .Password__strength-meter:after, .Password__strength-meter:before {
            outline-color: #fff;
            outline-style: solid;
            outline-width: 2px;
            width: 20%;
        }

        .Password__strength-meter:before {
            left: 20%;
        }

        .Password__strength-meter:after {
            right: 20%;
        }

        .Password__badge {
            bottom: 30px;
            right: 10px;
            padding: 4px 7px;
            width: 30px;
            height: 23px;
        }

        &.with-generator{
            input{
                padding-right: 75px;
            }
            .Password__badge{
                right: $form-elements-line-height;
            }
        }

    }

    .pwds-form {
        .fa-check-square {
            position: absolute;
            bottom: 11px;
            right: 11px;
            color: $success;
        }
    }

    .password-generator{
        position: absolute;
        right: 0;
        height: $form-elements-line-height;
        width: $form-elements-line-height;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/users/PasswordForm.vue